export default "__VITE_ASSET__C$EZHP9f__"